if (!customElements.get('bulk-atc')) {
  customElements.define(
    'bulk-atc',
    class BulkATC extends HTMLElement {
      constructor () {
        super();
        this.singleItemButtons = this.querySelectorAll('*[data-type="single"]');
        this.bulkButton = this.querySelector('*[data-type="bulk"]');
      }

      clickHandle (e) {
        const button = e.target.closest('button');
        if (!button.disabled) {
          let variants = button.getAttribute('data-variants');
          if (!variants) {
            button.disabled = true;
          } else {
            variants = variants.split(',').map((item) => {
              return item * 1;
            });
            this.addToCart(variants, button);
          }
        }
      }

      addToCart (items, button) {
        const loading = button.querySelector('.loading__spinner');
        document.querySelector('sticky-header').classList.add('loading-bar');
        if (loading) {
          loading.classList.remove('hidden');
        }
        let formData = {
          'items': [],
        };
        formData.items = items.map((item) => {
          return {
            quantity: 1,
            id: item,
          };
        });
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }).then(response => {
          return response.json();
        }).catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
          items.forEach((item) => {
            const singleButton = this.querySelector(`[data-variants="${item}"]`);
            if (singleButton) {
              singleButton.setAttribute('data-variants', '');
              singleButton.disabled = true;
              if (loading) {
                loading.classList.add('hidden');
                document.querySelector('sticky-header').classList.remove('loading-bar');
              }
            }
            let bulkVariants = this.bulkButton.getAttribute('data-variants');
            bulkVariants = bulkVariants.split(',').map((variant) => {
              return variant * 1;
            });
            if (bulkVariants.includes(item)) {
              bulkVariants = bulkVariants.filter(current => current !== item);
              if (!bulkVariants.length) {
                this.bulkButton.disabled = true;
                if (loading) {
                  loading.classList.add('hidden');
                  document.querySelector('sticky-header').classList.remove('loading-bar');
                }
                const modal = this.closest('advanced-modal');
                if (modal && modal.popupClose) {
                  modal.popupClose();
                }
              }
              bulkVariants = bulkVariants.join(',');
              this.bulkButton.setAttribute('data-variants', bulkVariants);
            }
            if (loading) {
              loading.classList.add('hidden');
            }
          });
        });
      }

      connectedCallback () {
        this.singleItemButtons.forEach((item) => {
          item.addEventListener('click', this.clickHandle.bind(this));
        });
        this.bulkButton.addEventListener('click', this.clickHandle.bind(this));
      }

      disconnectedCallback () {
        this.singleItemButtons.forEach((item) => {
          item.removeEventListener('click', this.clickHandle.bind(this));
        });
        this.bulkButton.removeEventListener('click', this.clickHandle.bind(this));
      }
    },
  );
}
